
const breadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Invoices',
        to: 'InvoiceList'
    }
]

export default [
    {
        path: '/invoices',
        name: 'InvoiceList',
        component: () => import('@/views/Invoices/ListPage.vue'),
        meta: {
            title: 'Invoices',
            breadcrumb: breadCrumb
        },
    },
    {
        path: '/invoices/:id/info',
        name: 'InvoiceInfo',
        component: () => import('@/views/Invoices/FormPage.vue'),
        meta: {
            title: 'Detalhes da Invoice',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Detalhes da Invoice',
                    to: 'InvoiceInfo'
                }
            ]
        }
    }
];